import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  const processSession = useCallback(async () => {
    const params = new URLSearchParams(location.hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    try {
      const { data } = await axios.post(
        `${API}/api/auth/google/session`,
        { session_id: sessionId },
        { withCredentials: true }
      );

      setUser(data);
      window.history.replaceState({}, document.title, '/dashboard');
      navigate('/dashboard', { replace: true, state: { user: data } });
    } catch (error) {
      console.error('Auth callback error:', error);
      navigate('/login', { replace: true });
    }
  }, [location.hash, navigate, setUser]);

  useEffect(() => {
    // Prevents double execution under React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processSession();
  }, [processSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#1E3A5F] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600" data-testid="auth-callback-loading">Iniciando sesión...</p>
      </div>
    </div>
  );
}
